module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.40d2001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_hero.png
// module id = YyxO
// module chunks = 0